<div class="dob-picker-container" [ngClass]="customClass" [class.is-invalid]="hasError || isUnderAge()">
  <div class="dob-icon-wrap" *ngIf="showIcon">
    <span class="material-symbols-outlined dob-icon">calendar_month</span>
  </div>

  <!-- Day Selector -->
  <div class="custom-select-box day-box" [class.active]="showDayDropdown">
    <div class="select-trigger" (click)="toggleDayDropdown($event)">
      <span class="selected-text" [class.placeholder]="!selectedDay">{{ selectedDay || 'Day' }}</span>
      <span class="material-symbols-outlined arrow-icon">expand_more</span>
    </div>
    <div class="dropdown-menu-list" *ngIf="showDayDropdown" (click)="$event.stopPropagation()">
      <div class="dropdown-item" (click)="selectDay('', $event)" [class.selected]="!selectedDay">Day</div>
      <div class="dropdown-item" *ngFor="let d of days" (click)="selectDay(d, $event)" [class.selected]="selectedDay === d">
        {{ d }}
      </div>
    </div>
  </div>

  <!-- Month Selector -->
  <div class="custom-select-box month-box" [class.active]="showMonthDropdown">
    <div class="select-trigger" (click)="toggleMonthDropdown($event)">
      <span class="selected-text" [class.placeholder]="!selectedMonth">{{ getMonthName(selectedMonth) || 'Month' }}</span>
      <span class="material-symbols-outlined arrow-icon">expand_more</span>
    </div>
    <div class="dropdown-menu-list" *ngIf="showMonthDropdown" (click)="$event.stopPropagation()">
      <div class="dropdown-item" (click)="selectMonth('', $event)" [class.selected]="!selectedMonth">Month</div>
      <div class="dropdown-item" *ngFor="let m of availableMonths" (click)="selectMonth(m.value, $event)" [class.selected]="selectedMonth === m.value">
        {{ m.name }}
      </div>
    </div>
  </div>

  <!-- Year Selector -->
  <div class="custom-select-box year-box" [class.active]="showYearDropdown">
    <div class="select-trigger" (click)="toggleYearDropdown($event)">
      <span class="selected-text" [class.placeholder]="!selectedYear">{{ selectedYear || 'Year' }}</span>
      <span class="material-symbols-outlined arrow-icon">expand_more</span>
    </div>
    <div class="dropdown-menu-list" *ngIf="showYearDropdown" (click)="$event.stopPropagation()">
      <div class="dropdown-item" (click)="selectYear('', $event)" [class.selected]="!selectedYear">Year</div>
      <div class="dropdown-item" *ngFor="let y of years" (click)="selectYear(y, $event)" [class.selected]="selectedYear === ('' + y)">
        {{ y }}
      </div>
    </div>
  </div>
</div>
